module.exports = __webpack_public_path__ + "static/media/photo89.af9261ac.jpg";